import React from 'react';
import WalterBanner from '../Assets/WalterBanner.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegramPlane, faTiktok, faDiscord, faInstagram } from '@fortawesome/free-brands-svg-icons';


function Footer() {
  return (
    <footer className="App-footer content-bubble3">
      <img src={WalterBanner} className="App-logo" alt="Walter banner" />
      <br />
      <br />
      <div className="social-links">
          <a href="https://twitter.com/Walter_TheWise" className="social-link" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>         
          <a href="https://instagram.com/walter_thewise" className="social-link" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://www.tiktok.com/@walter_thewise" className="social-link" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTiktok} />
          </a>
        </div>
      <br />
      © {new Date().getFullYear()} Developed by Gitatron for WalterTheWise. All rights reserved.
    </footer>
  );
}

export default Footer;
